module.exports = "/static/assets/33592a76d0d0fdaa4a32b2ea41db5e16.svg";